import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// El asistente responde en markdown (negritas, listas, tablas GFM). Solo se usa para los
// mensajes del asistente: lo que escribe el usuario se muestra como texto plano.
// react-markdown no renderiza HTML crudo (no hay dangerouslySetInnerHTML), así que es seguro.
const celda = (Tag, extra) => ({ children, style }) => (
  <Tag
    style={{
      border: '1px solid #dee2e6',
      padding: '3px 8px',
      whiteSpace: 'nowrap',
      textAlign: style && style.textAlign ? style.textAlign : 'left',
      ...extra,
    }}
  >
    {children}
  </Tag>
);

const COMPONENTES = {
  p: ({ children }) => <p style={{ margin: '0 0 8px' }}>{children}</p>,
  h1: ({ children }) => <div style={{ fontWeight: 700, margin: '8px 0 4px' }}>{children}</div>,
  h2: ({ children }) => <div style={{ fontWeight: 700, margin: '8px 0 4px' }}>{children}</div>,
  h3: ({ children }) => <div style={{ fontWeight: 700, margin: '8px 0 4px' }}>{children}</div>,
  h4: ({ children }) => <div style={{ fontWeight: 700, margin: '8px 0 4px' }}>{children}</div>,
  ul: ({ children }) => <ul style={{ paddingLeft: 20, margin: '0 0 8px' }}>{children}</ul>,
  ol: ({ children }) => <ol style={{ paddingLeft: 20, margin: '0 0 8px' }}>{children}</ol>,
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  code: ({ children }) => <code style={{ fontSize: 12 }}>{children}</code>,
  table: ({ children }) => (
    <div style={{ overflowX: 'auto', margin: '6px 0' }}>
      <table style={{ borderCollapse: 'collapse', fontSize: 12, width: 'auto', background: '#fff' }}>
        {children}
      </table>
    </div>
  ),
  thead: ({ children }) => <thead style={{ background: '#f1f3f5' }}>{children}</thead>,
  th: celda('th', { fontWeight: 600 }),
  td: celda('td', {}),
};

export default function RespuestaMarkdown({ texto }) {
  return (
    <div style={{ wordBreak: 'break-word' }}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTES}>
        {texto || ''}
      </ReactMarkdown>
    </div>
  );
}
